<template>
  <div>
    <section class="section1">
      <ul class="list">
        <li
          class="li"
          v-for="(item,i) of detail"
          :key="i"
          @click="detailClick(item)"
        >
          <div class="liCon">
            <p class="name ellipsis" :title="item.article_title_cn">
              {{item.article_title_cn}}
            </p>
            <p class="time">{{item.send_time}}</p>
          </div>
        </li>
      </ul>
      <!-- <el-pagination
        :background="true"
        :hide-on-single-page="true"
        layout="prev, pager, next"
        :total="1000"
        class="page"
        :current-page="page"
        @current-change="changePage"
      >
      </el-pagination> -->

    </section>
  </div>
</template>
<script>
import {ArticlegetList} from '../../api/Overview'
export default {
  data() {
    return {
      page: 1,
      detail:{list:[]},
      total:1
    };
  },
  methods: {
    //   翻页
    changePage(val) {
      this.page = val;
    },
    // 详情
    detailClick(item) {
      var laber=[0,30,18]
      var laPath=['/','/SchoolStrategy']
      var routeData=this.$router.resolve({
        path: "/NewsDetails",
        query: {
          laber: JSON.stringify(laber),
          laPath: JSON.stringify(laPath),
          id: item.article_id
        }
      });
       window.open(routeData.href, "_blank");
    },
    // 列表
    strategyList(){
      ArticlegetList({
      article_type_id:44,
      limit:10
    }).then(res=>{
      // console.log(res.data)
      this.detail=res.data.list
    })
    }
  },
  created(){
    this.strategyList()
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.section1 {
  width: px2Rem(1300px);
  margin: px2Rem(0px) auto px2Rem(60px);
  //   margin-bottom: px2Rem(60px);
  .list {
    font-size: 0;
    .li {
      padding: px2Rem(30px) px2Rem(15px);
      border-bottom:1px solid rgba(221,221,221,1);
      cursor: pointer;
      transition: .3s;
      &:hover {
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.3);
          .name{
              color: #1c3278;
          }
      }
        .name {
          margin-bottom: px2Rem(20px);
          font-size: px2Rem(28px);
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
        .time {
          font-size: px2Rem(18px);
          font-weight: 400;
          color: #666;
        }
      
    }
  }
}
.page {
  margin-top: px2Rem(40px);
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/SchoolStrategy/SchoolServing.vue